import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Plus, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { Field } from "./AdminMovies";
import { Modal } from "./AdminSeries";

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/categories").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (edit.id) await api.put(`/admin/categories/${edit.id}`, { name: edit.name, type: edit.type });
    else await api.post("/admin/categories", { name: edit.name, type: edit.type });
    toast.success("Saved");
    setEdit(null);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/categories/${id}`);
    load();
  };

  const grouped = items.reduce((acc, c) => {
    (acc[c.type] = acc[c.type] || []).push(c);
    return acc;
  }, {});

  return (
    <div data-testid="admin-categories-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>Categories</h1>
          <p className="text-[#888] text-sm">{items.length} total</p>
        </div>
        <button onClick={() => setEdit({ name: "", type: "movie" })} className="btn-primary" data-testid="add-category-btn"><Plus size={16} /> Add Category</button>
      </div>
      <div className="grid sm:grid-cols-3 gap-5">
        {Object.entries(grouped).map(([type, list]) => (
          <div key={type} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5">
            <h2 className="text-xs uppercase tracking-wider text-[#E50914] font-bold mb-3">{type}</h2>
            <div className="space-y-1.5">
              {list.map((c) => (
                <div key={c.id} className="flex items-center justify-between bg-[#0a0a0a] px-3 py-2 rounded">
                  <span className="text-sm">{c.name}</span>
                  <div className="flex gap-1">
                    <button onClick={() => setEdit(c)} className="text-[#aaa] hover:text-white p-1"><Pencil size={14} /></button>
                    <button onClick={() => del(c.id)} className="text-[#aaa] hover:text-[#E50914] p-1"><Trash2 size={14} /></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {edit && (
        <Modal title={edit.id ? "Edit Category" : "Add Category"} onClose={() => setEdit(null)} onSave={save}>
          <Field label="Name" value={edit.name} onChange={(v) => setEdit({ ...edit, name: v })} />
          <div>
            <label className="text-xs uppercase tracking-wider text-[#888] block mb-1.5">Type</label>
            <select value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })} className="w-full px-3 py-2 bg-[#1a1a1a] border border-white/10 rounded-md text-sm">
              <option value="movie">Movie</option>
              <option value="series">Series</option>
              <option value="channel">Channel</option>
            </select>
          </div>
        </Modal>
      )}
    </div>
  );
}
